import { Radio } from 'antd'

export {
  Radio
}



// WEBPACK FOOTER //
// ./src/components/radio.js